import * as THREE from 'three';
import ObjectArrayView from '../../generic/container/ObjectArrayView';
import ObjectBuffer from '../../generic/container/ObjectBuffer';
import PolyMesh from '../model/PolyMesh';
import PolyMap from '../model/PolyMap';

export default function removeDuplicateValues(polyMesh, withLogging) {

  //removes indentical values in the values array and remaps the indices
  //also has the side effect of removing values not used by a face

  const l = withLogging || false;

  const faceValueIndices = new Uint32Array(polyMesh.positions.faceValueIndices);
  const values = polyMesh.positions.values;

  const newValues = new ObjectBuffer(THREE.Vector3);

  const valueMappings = new Map();
  let newValuesLength = 0;

  let key = 0;
  let newIndex = 0;
  const value = new THREE.Vector3();
  const keyValue = new THREE.Vector3();

  const boundingBox = new THREE.Box3();
  boundingBox.setFromArray(new Float32Array(values.data));
  const boundingBoxDiagonalWithShift = boundingBox.getSize().length() * Math.pow(2, 17);

  for (let ix = 0; ix < faceValueIndices.length; ix++) {

    values.getAt(faceValueIndices[ix], value);
    //hash function scales values to the diagonal of the bounding box and stores 17 bits of precision in 3 buckets in a 64 bit float (52 bits usable)
    keyValue.subVectors(value, boundingBox.min).multiplyScalar(boundingBoxDiagonalWithShift);
    key = keyValue.x * 1000000000000 + keyValue.y * 100000 + keyValue.z;

    if (!valueMappings.has(key)) {
      valueMappings.set(key, newValuesLength);//save location of value in map
      newIndex = newValuesLength;
      newValues.push(value);//push value to the newValues array
      newValuesLength++;
    } else {
      newIndex = valueMappings.get(key);
    }

    faceValueIndices[ix] = newIndex;//update indices array with new value

  }

  if (l) console.log('' + values.length + ' values reduced to ' + newValuesLength + ', duplicates removed: ' + (values.length - newValuesLength));

  if (values.length === newValuesLength) return polyMesh;

  const newValuesArray = new ObjectArrayView(THREE.Vector3, newValuesLength);
  newValuesArray.fromArray(newValues.toArray());

  const newPositions = new PolyMap({
    faceRangeOffsets: polyMesh.faceRangeOffsets,
    faceValueIndices: faceValueIndices,
    values: newValuesArray,
  });

  const resultMesh = new PolyMesh(polyMesh);
  resultMesh.positions = newPositions;

  resultMesh.topologyChanged();
  return resultMesh;
};



// WEBPACK FOOTER //
// ./src/polyMesh/geometric/operator/removeDuplicateValues.js